import React from "react";

import {
  MailOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  GlobalOutlined,
  WhatsAppOutlined,
  UserOutlined,
} from "@ant-design/icons";
const Contact = () => {
  const links = [
    {
      title: "WhatsApp",
      icon: <WhatsAppOutlined style={{ fontSize: 18, color: "#fff" }} />,
      url: "https://wa.me/917092925555",
    },
    {
      title: "Email",
      icon: <MailOutlined style={{ fontSize: 18, color: "#fff" }} />,
      url: "mailto:suriya@divehrzn.com",
    },
    {
      title: "Website",
      icon: <GlobalOutlined style={{ fontSize: 18, color: "#fff" }} />,
      url: "https://divehrzn.com",
    },
    {
      title: "Instagram",
      icon: <InstagramOutlined style={{ fontSize: 18 }} />,
      url: "https://instagram.com/odyssey_of_suriya",
    },
    {
      title: "LinkedIn",
      icon: <LinkedinOutlined style={{ fontSize: 18 }} />,
      url: "https://linkedin.com/in/suriyaofficial",
    }
  ];

  return (
    <div className="page">
      <div className="card">
        <h1 className="logo">DIVE HRZN</h1>
        <p className="subtitle">Founder — Suriya</p>

        <p className="tag">Scubadiving | Skydiving | Travel</p>

        <div className="buttons">
          {links.map((link, i) => (
            <a key={i} href={link.url} className="btn" target="_blank">
              <span className="icon">{link.icon}</span>

              <span>{link.title}</span>
            </a>
          ))}
        </div>
      </div>

      <style jsx>{`
        .page {
          background: #000;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-family: sans-serif;
          padding: 20px;
        }

        .card {
          width: 100%;
          max-width: 420px;
          text-align: center;
        }

        .logo {
          font-size: 36px;
          font-weight: 800;
          letter-spacing: 3px;
        }

        .subtitle {
          opacity: 0.7;
          margin-bottom: 8px;
        }

        .tag {
          font-size: 13px;
          opacity: 0.5;
          margin-bottom: 30px;
        }

        .buttons {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .btn {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 10px;
          text-decoration: none;
          color: white;
          background: rgba(255, 255, 255, 0.03);
          transition: all 0.25s;
        }

        .btn:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }

        .icon {
          display: flex;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export default Contact;
